import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, Box, Typography, Drawer } from '@mui/material';
import { useModals } from '@mattjennings/react-modal-stack';
import Iconify from '@/components//Iconify';
import useMobile from '@/hooks/useMobile';
import Timer from './Timer';

const ConfirmTriesDialog = ({
  open,
  onConfirm = () => {},
  onClose = () => {},
  tries,
  variant = 'default',
}) => {
  const { t } = useTranslation();
  const { closeModal } = useModals();
  const { isMobile } = useMobile();

  if (!open) {
    return null;
  }

  const handleClose = () => {
    closeModal();
    onClose();
  };

  const handleAcept = () => {
    closeModal();
    onConfirm();
  };

  const text = (
    <>
      {variant === 'default' && (
        <>
          {tries > 1 && (
            <Typography
              paragraph
              sx={{
                margin: 0,
                padding: 0,
                color: (theme) => theme.palette.grey[700],
                mb: 4,
              }}
              variant="body2"
            >
              {t('checkout.home.saturated.retry')}
              <Typography
                sx={{
                  fontWeight: 600,
                }}
                variant="body2"
                component="span"
              >
                {t('checkout.home.saturated.retry2', { count: tries })}
              </Typography>
              {t('checkout.home.saturated.retry3')}
            </Typography>
          )}
          {tries == 1 && (
            <Typography
              paragraph
              sx={{
                margin: 0,
                padding: 0,
                color: (theme) => theme.palette.grey[700],
                mb: 4,
              }}
              variant="body2"
            >
              {t('checkout.home.saturated.changeOver')}
            </Typography>
          )}
        </>
      )}

      {variant === 'timeOut' && (
        <Typography
          paragraph
          sx={{
            margin: 0,
            padding: 0,
            color: (theme) => theme.palette.grey[700],
            mb: 4,
          }}
          variant="body2"
        >
          {t('checkout.home.saturated.timeOut')}
          <Typography
            sx={{
              fontWeight: 600,
            }}
            variant="body2"
            component="span"
          >
            {t('checkout.home.saturated.timeOut2')}
          </Typography>
          {t('checkout.home.saturated.timeOut3')}
        </Typography>
      )}
    </>
  );

  const body = (
    <>
      <Box
        sx={{
          mr: 2,
          mt: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
      >
        <Box
          sx={{
            'width': '20px',
            'height': '20px',
            'display': 'flex',
            'alignItems': 'center',
            'justifyContent': 'center',
            '&:hover': {
              cursor: 'pointer',
            },
          }}
          onClick={handleClose}
        >
          <Iconify
            width={16}
            height={16}
            icon={'material-symbols:close'}
            sx={{
              color: (theme) =>
                theme.palette.mode === 'light'
                  ? theme.palette.grey[800]
                  : theme.palette.grey[200],
            }}
          />
        </Box>
      </Box>
      <Box
        sx={{
          paddingTop: '16px',
          paddingLeft: '32px',
          paddingRight: '32px',
          paddingBottom: '16px',
        }}
      >
        <Box
          sx={{
            width: '100%',
          }}
        >
          <Timer variant="icon" />
        </Box>
        <Box
          sx={{
            mt: 2,
            width: '100%',
          }}
        >
          {text}
        </Box>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyItems: 'center',
          }}
        >
          <Button variant="contained" onClick={handleClose} autoFocus fullWidth>
            {t('checkout.buttons.continuePurchase')}
          </Button>
        </Box>
        {tries > 1 && variant === 'default' && (
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyItems: 'center',
            }}
          >
            <Button
              variant="text"
              onClick={handleAcept}
              autoFocus
              fullWidth
              sx={{
                color: (theme) => theme.palette.grey[600],
                textDecoration: 'underline',
              }}
            >
              {t('checkout.buttons.searchAnotherArea')}
            </Button>
          </Box>
        )}
      </Box>
    </>
  );

  return (
    <>
      {isMobile ? (
        <Drawer open={open} onClose={handleClose} anchor="bottom">
          {body}
        </Drawer>
      ) : (
        <Dialog open={open} onClose={handleClose} maxWidth="xs">
          {body}
        </Dialog>
      )}
    </>
  );
};

export default ConfirmTriesDialog;
